import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-success-story',
  templateUrl: './our-success-story.component.html',
  styleUrls: ['./our-success-story.component.scss']
})
export class OurSuccessStoryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }
  slidesSuccess = {
    slidesPerView: 3,
    spaceBetween: 50,
    loop: true,
    autoplay:false,
    centeredSlides: true,
    zoom: false,
    breakpoints:{
      320:{
        slidesPerView:1,

      },
      500:{
        slidesPerView:1,

      },
      767:{
        slidesPerView:2,

      },
    }
  }
}
